const toCss = (styles) =>
  Object.entries(styles)
    .map(([k, v]) => `${k}:${v} !important`)
    .join(";");

export function applyElementOverrides(overrides) {
  let styleEl = document.getElementById("element-overrides");
  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = "element-overrides";
    document.head.appendChild(styleEl);
  }
  let css = "";
  Object.entries(overrides || {}).forEach(([eid, o]) => {
    if (!o) return;
    const sel = `[data-eid="${eid}"]`;
    const dStyles = { ...(o.styles || {}) };
    if (o.hidden) dStyles.display = "none";
    if (Object.keys(dStyles).length) css += `${sel}{${toCss(dStyles)}}`;
    if (o.hideDesktop) css += `@media (min-width:769px){${sel}{display:none !important}}`;
    const mStyles = { ...(o.mobileStyles || {}) };
    if (o.hideMobile) mStyles.display = "none";
    if (Object.keys(mStyles).length) css += `@media (max-width:768px){${sel}{${toCss(mStyles)}}}`;

    document.querySelectorAll(sel).forEach((el) => {
      if (o.text !== undefined && o.text !== null) {
        if (el.dataset.origText === undefined) el.dataset.origText = el.textContent;
        if (el.textContent !== o.text) el.textContent = o.text;
      }
      if (o.href) {
        const link = el.tagName === "A" ? el : el.querySelector("a") || el.closest("a");
        if (link) link.setAttribute("href", o.href);
      }
      if (o.src && el.tagName === "IMG") {
        if (!el.dataset.origSrc) el.dataset.origSrc = el.src;
        const full = o.src.startsWith("/api") ? `${o.src}` : o.src;
        if (el.src !== full) el.src = full;
      }
      if (o.alt !== undefined && el.tagName === "IMG") el.alt = o.alt;
    });
  });
  styleEl.textContent = css;
}
